import type { MuiFareProfileOption } from '../../types/forms/MuiFareProfileOption';
import type { FareProfile } from '../../types/models/FareProfile';
import type { Mapper } from '../../types/mappers/Mapper';

export class MuiFareProfileOptionMapper implements Mapper<FareProfile, MuiFareProfileOption> {
    mapToView(data: Array<FareProfile> | FareProfile): Array<MuiFareProfileOption> | MuiFareProfileOption {
        if (Array.isArray(data)) {
            return data.map((datum) => {
                return {
                    id: datum.fareProfileId,
                    labelFR: datum.nameFR,
                    labelEN: datum.nameEN,
                    value: datum.code,
                };
            });
        }

        return {
            id: data.fareProfileId,
            labelFR: data.nameFR,
            labelEN: data.nameEN,
            value: data.code,
        };
    }

    mapToModel(data: MuiFareProfileOption | MuiFareProfileOption[]): Array<FareProfile> | FareProfile {
        throw new Error('Exception: not implemented');
    }
}
